import { formatDate, isSameDate, parseIso } from "@altek/ui/lib/format/date";

const pad = (value: number) => String(value).padStart(2, "0");

/**
 * İZNİN TARİHLERİ, KISA (31 Ekim 2026, Onay Merkezi). Onay kartının ilk satırı «16–18.11.2026 · 3 gün»:
 * karar verenin ilk sorusu «ne zaman». Ortak kısım bir kez yazılıyor — aynı ayda gün aralığı, aynı yılda
 * gün ve ay aralığı, yıl değişiyorsa iki tam tarih; tek günlük izin tek tarih. `formatDateRange`'in
 * «16.11.2026 – 18.11.2026»sı kartın dar sütununda iki satıra kırılıyordu.
 *
 * Tarihler iş günü metni (`YYYY-MM-DD`): `Date` üzerinden okunmuyor. Okunamayan uç `null` verir.
 */
export function compactDateRange(from: string | null | undefined, to: string | null | undefined): string | null {
  const start = parseIso(from ?? null);
  const end = parseIso(to ?? null) ?? start;
  if (!start || !end) return null;
  if (isSameDate(start, end)) return formatDate(start);
  if (start.year === end.year && start.month === end.month) return `${pad(start.day)}–${formatDate(end)}`;
  if (start.year === end.year) return `${pad(start.day)}.${pad(start.month)}–${formatDate(end)}`;
  return `${formatDate(start)} – ${formatDate(end)}`;
}
